import { render } from "./Customer.vue?vue&type=template&id=c1323106"
import script from "./Customer.vue?vue&type=script&lang=ts"
export * from "./Customer.vue?vue&type=script&lang=ts"
script.render = render

export default script